import clsx from 'clsx'
import type { HTMLAttributes } from 'react'

export interface SpinnerProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'role'> {
  size?: 'sm' | 'md' | 'lg'
  label?: string
}

const sizeClass: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-3 w-3 border-2',
  md: 'h-4 w-4 border-2',
  lg: 'h-6 w-6 border-[3px]',
}

export function Spinner({ size = 'md', label = 'Loading', className, ...rest }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={label}
      className={clsx('inline-flex items-center justify-center', className)}
      {...rest}
    >
      <span
        aria-hidden="true"
        className={clsx(
          'inline-block animate-spin rounded-full border-[var(--text-3)] border-t-[var(--accent)]',
          sizeClass[size],
        )}
      />
    </span>
  )
}
